      <ion-list class="legal-list" *ngIf="licenseType() === LicenseTypes.Colombia && hasFB() && isFbOnline()">
        <!--continuar literales-->
        <ion-list-header class="text-uppercase">{{'fb_sst_txt' | translate}}</ion-list-header>


        <ion-item class="legal-item has-bullet" *ngFor="let text of textInfoOnlineColombia; let index=index">
          <ion-label>
            <div class="bullet">
              <p>{{index + 1}}</p>
            </div>
            <p class="legal-message" [innerHTML]="text | translate"></p>
          </ion-label>
        </ion-item>
      </ion-list>

      <ion-list class="legal-list" *ngIf="hasFB() && isFbOnline()">
        <!--continuar literales-->
        <ion-list-header class="text-uppercase"
          >{{'fb_txt_active1' | translate}}<span *ngIf="licenseType() === LicenseTypes.Colombia"
            >&nbsp;ONLINE</span
          ></ion-list-header
        >
        <ion-item class="legal-item has-bullet" *ngFor="let text of textInfoOnlineAllCountries; let index=index">
          <ion-label>
            <div class="bullet">
              <p>{{index + 1}}</p>
            </div>
            <p class="legal-message" [innerHTML]="text | translate"></p>
          </ion-label>
        </ion-item>
      </ion-list>